<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Monitor from "@/services/Monitor";
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";

/**
 * Queue Details page
 */
export default {
    components: { Layout, PageHeader, DatePicker },
    page: {
        title: "Queue Details",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    data() {
        return {
            title: "Queues Details",
            items: [
                {
                    text: "Queue Details",
                },
                {
                    text: "Queues",
                    href: "/monitor/queues",
                },
            ],
            selectedKeys: [],
            selectedTenant: '',
            tenants: [],
            daterange: "",
            retrying: [],
            isBusy: false,
            isBusyFailed: false,
            isBusySuccess: false,

            failedQueue: '',
            successEventData: '',

            variation: this.$route.params.id,

            tableData_jobs: [],
            tableData_jobs_success: [],
            tableData_jobs_failed: [],
            error: null,

            totalRows_jobs: 0,
            totalRows_jobs_success: 0,
            totalRows_jobs_failed: 0,

            currentPage_jobs: 1,
            currentPage_jobs_success: 1,
            currentPage_jobs_failed: 1,

            perPage_jobs: 10,
            perPage_jobs_success: 10,
            perPage_jobs_failed: 10,

            pageOptions: [10, 25, 50, 100],

            filter_jobs: null,
            filter_jobs_success: null,
            filter_jobs_failed: null,

            filterOn_jobs: [],
            filterOn_jobs_success: [],
            filterOn_jobs_failed: [],

            sortBy_jobs: "queue",
            sortBy_jobs_success: "queue",
            sortBy_jobs_failed: "id",

            sortDesc: true,

            fields_jobs: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true,
                },
                {
                    key: "tenant",
                    label: "Tenant",
                    sortable: true,
                },
                {
                    key: "queue",
                    label: "Priority",
                    sortable: true,
                },
                {
                    key: "payload",
                    label: "UUID | Listener",
                    sortable: true,
                },
                {
                    key: "attempts",
                    label: "Attempts",
                    sortable: true,
                },
                {
                    key: "available_at_datetime",
                    label: "Available_at",
                    sortable: true,
                },
                {
                    key: "created_at_datetime",
                    label: "Created_at",
                    sortable: true,
                },
                "action",
            ],

            fields_jobs_failed: [
                {
                  key: 'selected',
                  label: '',
                  thStyle: { width: '40px' }
                },
                {
                    key: "id",
                    label: "ID",
                    sortable: true,
                },
                {
                  key: "tenant",
                  label: "Tenant",
                  sortable: true,
                },
                {
                    key: "uuid",
                    label: "UUID",
                    sortable: true,
                },
                {
                    key: "connection",
                    label: "Connection",
                    sortable: true,
                },
                {
                    key: "payload",
                    label: "Payload",
                    sortable: true,
                },
                {
                    key: "exception",
                    label: "Exception",
                    sortable: true,
                },
                {
                    key: "failed_at",
                    label: "Failed_at",
                    sortable: true,
                },
                "action",
            ],

            fields_jobs_success: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true,
                },
                {
                    key: "uuid",
                    label: "UUID",
                    sortable: true,
                },
                {
                    key: "tenant",
                    label: "Tenant",
                    sortable: true,
                },
                {
                    key: "env",
                    label: "Environment",
                    sortable: true,
                },
                {
                    key: "listener",
                    label: "Listener",
                    sortable: true,
                },
                {
                    key: "event_data",
                    label: "Event_data",
                    sortable: true,
                },
                {
                    key: "started_at",
                    label: "started_at",
                    sortable: true,
                },
                {
                    key: "finished_at",
                    label: "finished_at",
                    sortable: true,
                },
                {
                    key: "exec_time",
                    label: "exec_time",
                    sortable: true,
                },
            ]
        };
    },
    computed: {
        /**
         * Total no. of records
         */
        rows_jobs() {
            return this.tableData_jobs.length;
        },
        rows_success_jobs() {
            return this.tableData_jobs_success.length;
        },
        rows_failed_jobs() {
            return this.tableData_jobs_failed.length;
        },
        combinedWatcher() {
          return [this.daterange, this.selectedTenant];
        }
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.items.length;
    },
    async created() {
        await this.getTenants()
        this.getQueueJobs(this.variation)
        this.getQueueSuccessJobs(this.variation)
        this.getQueueFailedJobs(this.variation)
    },
    methods:{
      getTenants() {
        Monitor.getTenants()
            .then((response) => {
              this.tenants = response.data.tenants;
            })
            .catch((error) => {});
      },

        toggleBusyFailed() {
            this.isBusyFailed = !this.isBusyFailed
        },
        toggleBusySuccess() {
            this.isBusySuccess = !this.isBusySuccess
        },
        async getQueueJobs(variation){
            this.toggleBusy()
            let filter = this.getFilter()
            try {
                Monitor.getQueueJobs(variation, filter)
                .then(response => {
                    this.tableData_jobs = response.data.data;
                    this.toggleBusy()
                })
                .catch(error => {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.toggleBusy()
                })
            } catch (error) {
                this.error = error.response.data.error ? error.response.data.error : "Error";
                this.toggleBusy()
            }
        },
        async getQueueSuccessJobs(version){
            this.toggleBusySuccess()
            let filter = this.getFilter()

            try {
                Monitor.getQueueSuccessJobs(version, filter)
                .then(response => {
                    this.tableData_jobs_success = response.data.data;
                    this.toggleBusySuccess()
                })
                .catch(error => {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.toggleBusySuccess()
                })
            } catch (error) {
                this.error = error.response.data.error ? error.response.data.error : "Error";
                this.toggleBusySuccess()
            }
        },
        async getQueueFailedJobs(version){
            this.toggleBusyFailed()
            let filter = this.getFilter()

            try {
                Monitor.getQueueFailedJobs(version, filter)
                .then(response => {
                    this.tableData_jobs_failed = response.data.data;
                    this.toggleBusyFailed()
                })
                .catch(error => {
                    this.error = error.response.data.error ? error.response.data.error : "";
                    this.toggleBusyFailed()
                })
            } catch (error) {
                this.error = error.response.data.error ? error.response.data.error : "Error";
                this.toggleBusyFailed()
            }
        },

        sendInfo(failedQueue) {
            this.failedQueue = failedQueue
        },
        sendInfoEventData(data) {
            this.successEventData = data
        },
        clearText() {
            this.failedQueue = ''
            this.successEventData = ''
        },

        deleteFailedQueueJob(uuid){

          Swal.fire({
            title: "Delete Failed Queue Job",
            text: "This Failed Job will be deleted!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#34c38f",
            cancelButtonColor: "#f46a6a",
            confirmButtonText: "Delete!",
          }).then((result) => {
            if (result.value) {
              try {
                Monitor.deleteFailedQueueJob(uuid)
                    .then((response) => {
                      const res = response.data.delete ? response.data.delete : false;
                      const error = response.data.error ? response.data.error : 'Failed';
                      if(res){
                        this.getQueueFailedJobs(this.variation)
                        this.successmsg("Failed job removed");
                      }else{
                        this.failedmsg(error);
                      }
                    })
              }catch(error){
                this.error = error.response.data.error ? error.response.data.error : "";
              }
            }
          });
        },

        removeFromQueue(id){
            
            Swal.fire({
                title: "Delete Job from Queue",
                text: "This Jobs will be deleted from the Queue!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Move it!",
            }).then((result) => {
                if (result.value) {
                    try {
                        Monitor.deleteJobFromQueue(id, this.variation)
                        .then((response) => {
                            const res = response.data.delete ? response.data.delete : false;
                            const error = response.data.error ? response.data.error : 'Failed';
                            if(res){
                                this.getQueueJobs(this.variation)
                                this.successmsg("Job removed from Queue");
                            }else{
                                this.failedmsg(error);
                            }
                        })
                    }catch(error){
                        this.error = error.response.data.error ? error.response.data.error : "";
                    }
                }
            });
        },

      async retryFailedJob(uuid = '') {
        let jobIds = [];

        if (!uuid) {
          if (!this.selectedKeys.length) {
            return this.failedmsg('Select UUIDs to retry failed job');
          }
          jobIds = this.selectedKeys;
        } else {
          jobIds = [uuid];
        }

        this.retrying.push(...jobIds);

        try {
          const response = await Monitor.retryFailedQueueJob({
            uuid: jobIds,
          });

          // FIX: access the array inside response.data.data
          const results = response.data.data || [];

          const failedItems = results.filter(item => Number(item.exit) !== 0);

          if (failedItems.length > 0) {
            const failedUUIDs = failedItems.map(x => x.uuid).join(', ');
            this.failedmsg(`Retry failed for:`, `${failedUUIDs}`);
          } else {
            this.successmsg('Successfully Scheduled Queue Job');
          }

          await this.getQueueJobs(this.variation);
          await this.getQueueSuccessJobs(this.variation);
          await this.getQueueFailedJobs(this.variation);
        } catch (error) {
          this.error = error?.response?.data?.error || "Error";
          this.failedmsg(this.error);
        } finally {
          // remove from retrying list after done
          this.retrying = this.retrying.filter(id => !jobIds.includes(id));
        }
      },

        getFilter(){

          let filter = '';

          if(this.selectedTenant){
              filter +='&tenant='+this.selectedTenant
          }

          if (this.daterange && this.daterange.length === 2) {
            const [start, end] = this.daterange;
            const dateFrom = this.formatLocalDate(start);
            const dateTo = this.formatLocalDate(end);
            filter += `&date_from=${dateFrom}&date_to=${dateTo}`;
          }

          return filter;
        },

        formatLocalDate(date) {
          const d = new Date(date);
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        },

        clearFilters() {
          this.selectedTenant = ''
          this.daterange = null;
          this.totalRows_jobs = 0
          this.totalRows_jobs_success = 0
          this.totalRows_jobs_failed = 0
          this.tableData_jobs = []
          this.tableData_jobs_success = []
          this.tableData_jobs_failed = []
          this.currentPage_jobs = 1
          this.currentPage_jobs_success = 1
          this.currentPage_jobs_failed = 1
        }
    },
    watch: {
      combinedWatcher: {
        handler() {
          this.getQueueJobs(this.variation)
          this.getQueueSuccessJobs(this.variation)
          this.getQueueFailedJobs(this.variation)
          this.retrying = []
          this.selectedKeys = []
        },
        deep: true
      }
    },
    middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
        <div class="col-12">

          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-3 d-inline-flex align-items-center">
                  <label class="control-label form-label" style="width: 180px">Filter by Tenant</label>
                  <select
                      v-model="selectedTenant"
                      class="form-control form-select"
                      name="option"
                      type="select"
                  >
                    <option value="" key=""></option>
                    <option v-for="tenant in tenants" :key="tenant" :value="tenant">
                      {{ tenant }}
                    </option>
                  </select>
                </div>

                <div class="col-md-4 d-inline-flex align-items-center">
                  <label class="control-label form-label" style="width: 180px">Choose Dates</label>
                  <date-picker
                      v-model="daterange"
                      range
                      append-to-body
                      lang="en"
                      confirm
                  ></date-picker>
                </div>

                <div class="col-md-4 d-inline-flex align-items-center">
                  <button
                      class="btn btn-outline-danger btn-sm"
                      @click="clearFilters"
                  >
                    <i class="mdi mdi-filter-remove me-1"></i>
                    Clear All
                  </button>
                </div>

              </div>
            </div>
          </div>

            <div class="card">
                <div class="card-body">

                    <h3 class="card-title text-danger">Jobs In Queues</h3>

                    <div class="row mt-4">
                        <div class="col-sm-12 col-md-6">
                            <div class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Show&nbsp;
                                <b-form-select
                                        v-model="perPage_jobs"
                                        size="sm"
                                        :options="pageOptions"
                                ></b-form-select
                                >&nbsp;entries
                            </label>
                            </div>
                        </div>
                        <!-- Search -->
                        <div class="col-sm-12 col-md-6">
                            <div class="dataTables_filter text-md-end">
                            <label class="d-inline-flex align-items-center">
                                Search:
                                <b-form-input
                                        v-model="filter_jobs"
                                        type="search"
                                        placeholder="Search..."
                                        class="form-control form-control-sm ms-2"
                                ></b-form-input>
                            </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="table-responsive mb-0">
                            <b-table
                                :busy="isBusy"
                                :items="tableData_jobs"
                                :fields="fields_jobs"
                                responsive="sm"
                                :per-page="perPage_jobs"
                                :current-page="currentPage_jobs"
                                :sort-by.sync="sortBy_jobs"
                                :sort-desc.sync="sortDesc"
                                :filter="filter_jobs"
                                :filter-included-fields="filterOn_jobs"
                                show-empty
                                empty-text="No Data Found"
                            >
                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong>Loading...</strong>
                                    </div>
                                </template>

                                <template v-slot:cell(payload)="data">
                                    <p>{{ JSON.parse(data.item.payload).uuid}} | {{ JSON.parse(data.item.payload).displayName}}</p>
                                </template>

                                <template v-slot:cell(action)="data">
                                    <ul class="list-inline mb-0">
                                        <a href="javascript:void(0);" class="px-2 text-danger" title="Remove from Queue" @click="removeFromQueue(data.item.id)">
                                            <i class="uil uil-trash-alt font-size-18"></i>
                                        </a>
                                    </ul>
                                </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                <ul class="pagination pagination-rounded">
                                    <!-- pagination -->
                                    <b-pagination
                                    v-model="currentPage_jobs"
                                    :total-rows="rows_jobs"
                                    :per-page="perPage_jobs"
                                    ></b-pagination>
                                </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h3 class="card-title text-danger mt-5">Failed Jobs</h3>

                    <div class="row mt-4">
                        <div class="col-sm-12 col-md-2">
                            <div class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Show&nbsp;
                                <b-form-select
                                        v-model="perPage_jobs_failed"
                                        size="sm"
                                        :options="pageOptions"
                                ></b-form-select
                                >&nbsp;entries
                            </label>
                            </div>
                        </div>
                        <div class="col-sm-12 col-md-6">
                          <button
                              class="btn btn-primary btn-sm"
                              :disabled="!selectedKeys.length || selectedKeys.some(id => retrying.includes(id))"
                              @click="retryFailedJob()"
                          >
                            <i class="uil uil-refresh font-size-18"></i> Retry Selected ({{ selectedKeys.length }})
                          </button>
                        </div>
                        <!-- Search -->
                        <div class="col-sm-12 col-md-4">
                            <div class="dataTables_filter text-md-end">
                            <label class="d-inline-flex align-items-center">
                                Search:
                                <b-form-input
                                        v-model="filter_jobs_failed"
                                        type="search"
                                        placeholder="Search..."
                                        class="form-control form-control-sm ms-2"
                                ></b-form-input>
                            </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="table-responsive mb-0">
                            <b-table
                                :busy="isBusyFailed"
                                :items="tableData_jobs_failed"
                                :fields="fields_jobs_failed"
                                responsive="sm"
                                :per-page="perPage_jobs_failed"
                                :current-page="currentPage_jobs_failed"
                                :sort-by.sync="sortBy_jobs_failed"
                                :sort-desc.sync="sortDesc"
                                sort-icon-left
                                :filter="filter_jobs_failed"
                                :filter-included-fields="filterOn_jobs_failed"
                                show-empty
                                empty-text="No Data Found"
                            >

                              <template #table-busy>
                                <div class="text-center text-danger my-2">
                                  <b-spinner class="align-middle"></b-spinner>
                                  <strong>Loading...</strong>
                                </div>
                              </template>

                              <template #cell(selected)="data">
                                <input
                                    type="checkbox"
                                    :value="data.item.uuid"
                                    v-model="selectedKeys"
                                />
                              </template>

                              <template v-slot:cell(payload)="data">
                                  <p>{{ JSON.parse(data.item.payload).displayName}}</p>
                              </template>
                              <template v-slot:cell(exception)="data">
                                  <p>
                                      {{data.item.exception.slice(0, 20)}} ...
                                      <i class="mdi mdi-2px mdi-format-list-bulleted text-danger" v-b-modal.failed_queue_error @click="sendInfo(data.item.exception)"></i>
                                  </p>

                              </template>
                              <template v-slot:cell(action)="data">
                                <ul class="list-inline mb-0">
                                  <li class="list-inline-item">
                                    <a href="javascript:void(0);"
                                       class="px-2 text-primary"
                                       title="Retry Move to Queue"
                                       @click="retryFailedJob(data.item.uuid)"
                                       :class="{ 'disabled text-muted': retrying.includes(data.item.uuid) }"
                                       :style="{ pointerEvents: retrying.includes(data.item.uuid) ? 'none' : 'auto' }"
                                    >
                                      <i class="uil uil-refresh font-size-18"></i>
                                    </a>
                                  </li>
                                  <li class="list-inline-item">
                                    <a href="javascript:void(0);" class="px-2 text-danger" title="Remove Failed Job" @click="deleteFailedQueueJob(data.item.uuid)">
                                      <i class="uil uil-trash-alt font-size-18"></i>
                                    </a>
                                  </li>
                                  </ul>
                              </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                <ul class="pagination pagination-rounded">
                                    <!-- pagination -->
                                    <b-pagination
                                    v-model="currentPage_jobs_failed"
                                    :total-rows="rows_failed_jobs"
                                    :per-page="perPage_jobs"
                                    ></b-pagination>
                                </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    <h3 class="card-title text-danger mt-5">Success Jobs</h3>

                    <div class="row mt-4">
                        <div class="col-sm-12 col-md-6">
                            <div class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Show&nbsp;
                                <b-form-select
                                        v-model="perPage_jobs_success"
                                        size="sm"
                                        :options="pageOptions"
                                ></b-form-select
                                >&nbsp;entries
                            </label>
                            </div>
                        </div>
                        <!-- Search -->
                        <div class="col-sm-12 col-md-6">
                            <div class="dataTables_filter text-md-end">
                            <label class="d-inline-flex align-items-center">
                                Search:
                                <b-form-input
                                        v-model="filter_jobs_success"
                                        type="search"
                                        placeholder="Search..."
                                        class="form-control form-control-sm ms-2"
                                ></b-form-input>
                            </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="table-responsive mb-0">
                            <b-table
                                :busy="isBusySuccess"
                                :items="tableData_jobs_success"
                                :fields="fields_jobs_success"
                                responsive="sm"
                                :per-page="perPage_jobs_success"
                                :current-page="currentPage_jobs_success"
                                :sort-by.sync="sortBy_jobs_success"
                                :sort-desc.sync="sortDesc"
                                :filter="filter_jobs_success"
                                :filter-included-fields="filterOn_jobs_success"
                                show-empty
                                empty-text="No Data Found"
                            >
                              <template #table-busy>
                                <div class="text-center text-danger my-2">
                                  <b-spinner class="align-middle"></b-spinner>
                                  <strong>Loading...</strong>
                                </div>
                              </template>

                              <template v-slot:cell(event_data)="data">
                                      <i class="mdi mdi-18px mdi-format-list-bulleted text-danger" v-b-modal.success_event_data @click="sendInfoEventData(data.item.event_data)"></i>
                              </template>

                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-end">
                                <ul class="pagination pagination-rounded">
                                    <!-- pagination -->
                                    <b-pagination
                                    v-model="currentPage_jobs_success"
                                    :total-rows="rows_success_jobs"
                                    :per-page="perPage_jobs_success"
                                    ></b-pagination>
                                </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>


    <!-- MODALS -->
    <b-modal
        id="failed_queue_error"
        size="xl"
        title="Failed Queue Exception"
        title-class="font-18"
        hide-footer
        @hidden="clearText"
    >
    {{failedQueue}}
    </b-modal>

    <b-modal
        id="success_event_data"
        size="xl"
        title="Event Data"
        title-class="font-18"
        hide-footer
        @hidden="clearText"
    >
    {{successEventData}}
    </b-modal>

  </Layout>
</template>
